<template>
	<Badge :status="statusDisplay" :text="text" v-bind="filteredAttrs" />
</template>

<script>
import { computed, toRef } from 'vue';
import { Badge } from 'ant-design-vue';

import { useI18n } from 'vue-i18n';

export default {
	components: {
		Badge,
	},
	props: {
		source: {
			// if object, use field as key
			type: [Object, String],
			required: true,
		},
		field: {
			type: String,
			required: false,
			default: null,
		},
		badgeDict: {
			type: Object,
			required: true,
		},
		badgeDefault: {
			type: String,
			required: false,
			default: 'default',
		},
		prefix: {
			type: String,
			required: true,
		},
	},
	setup(props, { attrs }) {
		const { t } = useI18n();
		const sourceRef = toRef(props, 'source');
		const fieldRef = toRef(props, 'field');
		const badgeDictRef = toRef(props, 'badgeDict');
		const badgeDefaultRef = toRef(props, 'badgeDefault');
		const prefixRef = toRef(props, 'prefix');
		const status = computed(() => {
			if (sourceRef.value == null) {
				return 'unknown';
			}
			if (typeof sourceRef.value === 'object') {
				if (fieldRef.value == null) {
					throw new Error('field is required');
				}
				return sourceRef.value[fieldRef.value] || 'unknown';
			}
			return sourceRef.value;
		});
		const statusDisplay = computed(() => {
			if (status.value == 'unknown') {
				return badgeDefaultRef.value;
			}
			return badgeDictRef.value[status.value] || badgeDefaultRef.value;
		});
		const text = computed(() => {
			return t(prefixRef.value + '.' + status.value);
		});
		const filteredAttrs = computed(() => {
			const result = {
				...attrs,
				...props,
			}
			delete result.prefix;
			return result;
		});
		return {
			statusDisplay,
			text,
			filteredAttrs,
		};
	},
}
</script>
